export const nlResources = {
  translation: {
    Onboarding: "Onboarding",
    Select: "Bevestig",
    Add: "Voeg toe",
    Cancel: "Annuleer",
    Next: "Volgende",
    Previous: "Vorige",
    "See all": "Zie alles",
    Submitted: "Verstuurd",
    Submit: "Verstuur",
    Confirm: "Bevestig",
    Required: "Verplicht",
    "Onboarding successful": "Onboarding succesvol",
    "Onboarding failed - contact evsupport@eplucon.nl":
      "Onboarding mislukt - contact evsupport@eplucon.nl",

    "Let's get started": "Laten we beginnen!",
    "Onboard your charger in just a few steps":
      "Onboard je laadpaal in een paar stappen",
    "Onboarding is now complete": "Onboarding is nu voltooid",

    // Start
    "This onboarding tool is intended for new users of Monta. For expansion, please contact Eplucon.":
      "Deze onboarding tool is bedoeld voor nieuwe gebruikers van Monta. Neem bij uitbreiding contact op met Eplucon.",

    // Side carousel
    "Onboard your charging station at Monta and you can start immediately. Monta gives you plenty of options to use your charging station the way you want. Determine your own rates and to whom which rate applies, or set free charging. It's all possible with Monta!":
      "Onboard jouw laadpaal bij Monta en je kunt direct van start. Monta geeft je volop mogelijkheden om jouw laadpaal te gaan gebruiken zoals jij het wilt. Bepaal je eigen tarieven en voor wie welk tarief van toepassing is, of stel gratis laden in. Het kan allemaal met Monta!",

    // Tier options
    Basic: "Basis",
    "Charging at home, visitor can only charge with own Monta account. (Maximum 3 charging points)":
      "Thuis laden, bezoeker kan alleen laden met eigen Monta account. (Maximaal 3 laadpunten)",
    Sponsored: "Sponsored",
    "Charging at home with automatic settlement between employer and employee.":
      "Thuis laden met automatische verrekening tussen werkgever en werknemer.",
    Commercial: "Commercieel",
    "The best solution for commercial charging for both companies and private individuals with all functionalities.":
      "De beste oplossing voor commercieel laden voor zowel  bedrijf en particulier met alle functionaliteiten. ",

    // Tier table
    Costs: "Kosten",
    Subscription: "Abonnement",
    "Paid charging session": "Betaalde laadsessie",
    "Free or sponsored charging session": "Gratis of gesponsorde Laadsessie",
    "Basis (incl. VAT)": "Basis (incl. BTW)",
    Free: "Gratis",
    "0.24 starting rate and 7.5% per transaction":
      "0,24 starttarief en 7,5% per transactie",
    "0.24 starting rate, no transaction costs":
      "0,24 starttarief, geen transactie- kosten",
    "Sponsored (excl. VAT)": "Sponsored (excl. BTW)",
    "€ 7,44": "€ 7,44",
    "0.20 starting rate and 7.5% per transaction":
      "0,20 starttarief en 7,5% per transactie",
    "0.20 starting rate, no transaction costs":
      "0,20 starttarief, geen transactie- kosten",
    "Commercial (excl. VAT)": "Commercieel (excl. BTW)",

    "Which option is best suited to your situation?":
      "Welke optie is het meest geschikt voor uw situatie?",
    Compare: "Vergelijk",

    // Tier Compare
    "Basic (incl. VAT) Max. 3 charging points)":
      "Basis (incl. BTW) Max. 3 oplaadpunten)",
    Employee: "Werknemer",
    Employer: "Werkgever",
    "€7.44 per month, per socket": "€ 7,44 per maand, per socket",
    "Paid charging session costs": "Kosten betaalde laadsessie",
    "0.24 starting rate and 15% transaction costs":
      "0,24 starttarief en 15% transactiekosten",
    "0.20 starting rate and 7.5% transaction costs":
      "0,20 starttarief en 7,5% transactiekosten",
    "Costs sponsored or free charging session":
      "Kosten gesponsorde of gratis laadsessie",
    "Optional: 4G Connectivity": "Optioneel: 4G Connectiviteit",
    "€3.63 per month, per socket": "€ 3,63 per maand, per socket",
    "€3.00 per month, per socket": "€ 3,00 per maand, per socket",
    "Email support (In Monta, English)": "Email support(In Monta, engelstalig)",
    "Unlimited in team members": "Onbeperkt in teamleden",
    "Roaming: public charging for everyone":
      "Roaming: openbaar laden voor iedereen",
    "Loading for other Monta users": "Laden voor andere Monta gebruikers",
    "Pay with your team Wallet": "Betalen met je team Wallet",
    "Charging drops for team": "Laaddruppels voor team",
    "Pay afterwards (per month)": "Achteraf betalen (per maand)",
    "Loading balancing": "Load balancing",

    // Plan details
    "Unlimited Team Members": "Onbeperkt in aantal teamleden",
    "Monthly Cost": "Maandelijkse kosten",
    "Transaction Fee": "Transactiekosten",
    "Tech Support": "Tech support (alleen voor beheerders / eigenaren)",
    "24/7 Support": "24/7 support",
    Portal: "Portaal",
    Dashboard: "Dashboard",
    "Transaction Overview": "Inzicht in transacties",
    "Smart Queue": "Slimme wachtrij",
    "Load Balancing": "Load Balancing",
    "Advanced Features": "Geavanceerde mogelijkheden",
    "Pay with team wallet": "Betalen met je team wallet",
    "Team charge keys": "Laaddruppels voor teams",
    "Pay by invoice": "Betalen per factuur",
    "Sponsored chargepoints": "Gesponsorde EV-opladers",
    Roaming: "Roaming",
    "Enterprise security": "Hoogwaardige veiligheid",

    // Chargepoint
    Chargepoint: "EV-oplader",
    "Search Serial Number": "Zoek serienummer",
    "Add Sim": "Activeer de simkaart",
    "Additional €8/month per sim": "Toeslag €3,- p/maand",
    Chargepoints: "EV-opladers",
    Connectors: "Connectoren",
    Summary: "Samenvatting",
    "Serial Number": "Serienummer",
    Model: "Model",
    "Max Power": "Maximaal vermogen",

    // Company
    "Tax ID": "BTW nummer",
    Company: "Bedrijf",
    Name: "Naam",
    "Optional (for companies)": "Optioneel (voor bedrijven)",
    "Search Address": "Zoek adres",
    Street: "Straat",
    City: "Stad",
    "Zip Code": "Postcode",
    Country: "Land",

    // Guidance text
    "Something went wrong, please try again":
      "Er ging iets mis, probeer het nog eens",
    "Please enter a valid serial number": "Voer een geldig serienummer in",
    "Please add a chargepoint": "Voeg een EV-oplader toe",
    "Please enter a valid street": "Voer een geldige straat in",
    "Please enter a valid city": "Voer een geldige plaats in",
    "Please enter a valid zip code": "Voer een gelde postcode in",
    "Please enter a valid name": "Voer een geldige naam in",
    "Please enter a valid telephone number":
      "Voer een geldig telefoonnummer in",
    "Please enter a valid email": "Voer een geldig emailadres in",
    "Email address is already in use": "Emailadres is al in gebruik",

    // The rest
    "Phone Number": "Telefoonnummer",
    "Email Address": "Emailadres",
    "Team Name": "Team naam",
    "Team Owner": "Contactpersoon",
    "Employee data": "Gegevens werknemer",
    "Email address (this must be different from the company email address)":
      "Emailadres (deze moet afwijken van mailadres bedrijf)",
    "Owner Name": "Naam eigenaar",
    "Owner Telephone": "Telefoonnummer contactpersoon",
    "Owner Email": "Emailadres contactpersoon",
    "Employer details": "Gegevens werkgever",
    "Employer contact person": "Contactpersoon werkgever",
    "Administration contact person": "Contactpersoon administratie",
    "Team Finance": "Team administratie",
    "Finance Name": "Naam administratie",
    "Finance Telephone": "Telefoonnummer administratie",
    "Finance Email": "Emailadres administratie",
    "Team Installer": "Installateur",
    "Installer Name": "Naam installateur",
    "Installer Telephone": "Telefoonnummer installateur",
    "Installer Email": "Emailadres installateur",
    "Installation Notes (optional)": "Opmerkingen voor de monteur (optioneel)",
    Site: "Locatie EV-oplader",
    "Private EV charger address": "Privé adres EV-oplader",
    "Site Name": "Locatie naam",
  },
};
